import CustomDrawer, { CustomDrawerProps } from '@/components/atoms/CustomDrawer';

export type ReportDrawerProps = CustomDrawerProps;

export default CustomDrawer;
